import { func, string } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Button from 'ravenjs/lib/Button';
import { Typography } from 'ravenjs/lib';

import { DEFAULT_COLORS } from 'constants/colors';
import USERS from 'constants/users';

const ImpersonationSectionWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex: 1 1 auto;
    min-width: 0;
    width: 100%;

    @media (max-width: 675px) {
        align-items: flex-start;
    }
`;

const TextContainer = styled.div`
    display: block;
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
`;

const ButtonWrapper = styled.div`
    flex: 0 0 auto;
    align-self: center;
`;

const ButtonStyled = styled(Button)`
    font-size: 14px;
    font-family: 'Roboto';
`;

const ImpersonationSection = ({ impersonatedName, onEndSession }) => {
    const prefix = USERS.IMPERSONATION_HEADER;
    const title = `${prefix} ${impersonatedName}`;

    return (
        <ImpersonationSectionWrapper>
            <TextContainer title={title}>
                <Typography
                    as="span"
                    fontStyle="Bold"
                    fontWeight="700"
                    fontFamily="Roboto"
                    fontSize="16px"
                    lineHeight="150%"
                    gutterTop="0"
                    gutterBottom="0"
                    color={DEFAULT_COLORS.BLACK_00}
                >
                    {`${prefix}\u00A0`}
                </Typography>
                <Typography
                    as="span"
                    fontWeight="400"
                    fontSize="16px"
                    fontFamily="Roboto"
                    lineHeight="150%"
                    gutterTop="0"
                    gutterBottom="0"
                    color={DEFAULT_COLORS.BLACK_00}
                >
                    {impersonatedName}
                </Typography>
            </TextContainer>
            <ButtonWrapper>
                <ButtonStyled onClick={onEndSession} color="primary">
                    {USERS.IMPERSONATION_END_SESSION_BUTTON}
                </ButtonStyled>
            </ButtonWrapper>
        </ImpersonationSectionWrapper>
    );
};

ImpersonationSection.propTypes = {
    impersonatedName: string.isRequired,
    onEndSession: func.isRequired,
};

export default ImpersonationSection;
